const qPath = require('./qpath');
const strToUrlpath = require('./str2urlpath');

function questionPath(title, localePath) {
  return qPath(strToUrlpath(title), localePath);
}

module.exports = questionPath;
